
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/favoriten/[slug]",
      function () {
        return require("private-next-pages/favoriten/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/favoriten/[slug]"])
      });
    }
  